module.exports = __webpack_public_path__ + "img/汇源街道.2972a4a1.png";